import CertificateRepayment from './CertificateRepayment'

export { CertificateRepayment }
